<template>
  <div>
    <div class="page-header">
      <parallax
        class="page-header-image"
        style="background-image: url('img/goal.jpg')"
      >
      </parallax>
        <div class="content-center brand">
          <img class="n-logo" src="img/logo-wit.svg" alt="" />
        </div>
    </div>
    <div class="section my-4 section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h3 class="text-primary">
                Our primary focus as a business is the delivery of investment outperformance after fees over the long term to our clients within a strict governance framework.
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, FormGroupInput } from '@/components';
export default {
  name: 'landing',
  bodyClass: 'landing-page'
};
</script>
<style></style>
